/* ══════════════════════════════════════════════════════════
   Shared Money Formatting — Aykah Theme
   Loaded globally before other scripts.
   Usage: window.AykahFormatMoney(cents)
          window.AykahFormatMoneyShort(cents)
   ══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /**
   * Format cents to CAD currency string.
   * @param {number|string} cents — price in cents (Shopify standard)
   * @returns {string} e.g. "$1,299.00"
   */
  function formatMoney(cents) {
    var num = parseInt(cents, 10);
    if (isNaN(num)) return '$0.00';
    return '$' + (num / 100).toLocaleString('en-CA', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  /**
   * Format cents to short CAD currency (no decimals for whole dollars).
   * @param {number|string} cents — price in cents
   * @returns {string} e.g. "$1,299"
   */
  function formatMoneyShort(cents) {
    var num = parseInt(cents, 10);
    if (isNaN(num)) return '$0';
    return '$' + Math.round(num / 100).toLocaleString('en-CA');
  }

  window.AykahFormatMoney = formatMoney;
  window.AykahFormatMoneyShort = formatMoneyShort;
})();
